export enum GfxGedRenderingMode {
    Grid = 1,
    List = 2
}